import { theme } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { ProviderContext } from '../Provider'
import { setIntersectionObserver } from '../utils/setIntersectionObserver'
import { StickyPricing } from './shared'

const SmartStickyStyle = styled.div`
  + footer {
    margin-bottom: 96px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      margin-bottom: 112px;
    }
  }
  .sticky-element {
    transition: max-height 1s ease-in;
    max-height: 0;
    &.show {
      max-height: 100%;
      height: auto;
    }
  }
`

export const SmartSticky = ({ targetId = '', ...props }) => {
  const { state, simpleStateUpdater } = useContext(ProviderContext)
  const targetElement = targetId ? document.querySelector(`#${targetId}`) : null
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)

  // fallback for browsers that don't support intersectionObserver
  if (
    (!'IntersectionObserver' in window &&
      !'IntersectionObserverEntry' in window &&
      !'intersectionRatio' in window.IntersectionObserverEntry.prototype) ||
    isSafari
  ) {
    const handleScroll = function () {
      if (targetElement) {
        const position = targetElement.getBoundingClientRect()
        if (position.top <= 0 && position.bottom <= window.innerHeight) {
          simpleStateUpdater([{ state: 'showSticky', value: true }])
          window.removeEventListener('scroll', handleScroll)
        }
      }
    }
    if (!state.showSticky) window.addEventListener('scroll', handleScroll)
  } else {
    if (targetElement) {
      setIntersectionObserver({
        targetElement,
        onIntersecting: () => {
          document.querySelector('.sticky-element').classList.add('show')
          if (!state.showSticky) {
            simpleStateUpdater([{ state: 'showSticky', value: true }])
          }
        },
      })
    }
  }

  return (
    <SmartStickyStyle>
      <StickyPricing
        loading={state.isFetching}
        className={`sticky-element ${state.showSticky ? 'show' : ''}`}
        {...props}
        showModal={state.showModal}
      />
    </SmartStickyStyle>
  )
}
